{
    "actions": {
        "row": {
            "emergency_collect": "Emergency remote collection"
        }
    },
    "filter": {
        "placeholder": {
            "label_merchant": "Filter by merchant label",
            "email_merchant": "Filter by merchant email",
            "manufacturer": "Filter by manufacturer",
            "model": "Filter by model",
            "organization": "Filter by organization",
            "pos_label": "Filter by POS label",
            "package_label": "Filter by customization",
            "package_code": "Filter by ident. code",
            "provider_legal_name": "Filter by direct provider",
            "serial_number": "Filter by serial #",
            "version_pax": "Filter by Pax version",
            "version_payludd": "Filter by Payludd version",
            "version_android": "Filter by Android version"
        }
    },
    "keys": {
        "download_date": "Download date",
        "email_merchant": "Merchant email",
        "label_merchant": "Merchant label",
        "last_connection_date": "Last connected on",
        "manufacturer": "Manufact.",
        "model": "Model",
        "organization": "Organization",
        "pos_label": "POS label",
        "package_label": "Customization",
        "package_code": "Ident. code",
        "package_initialization_status": "Init. status",
        "provider_legal_name": "Direct provider",
        "serial_number": "Serial #",
        "subscriptions_status": "Gateway subscr.",
        "version_pax": "Pax V.",
        "version_payludd": "Payludd V.",
        "version_android": "Android V.",
        "contract": {
            "profiles": {
                "application": "Application",
                "number": "Number",
                "bank_code": "Bank code",
                "rank": "Rank",
                "label": "Label"
            }
        }
    },
    "modal": {
        "emergency_remote_collection": {
            "title": "Emergency remote collection",
            "warning": {
                "subtitle": "Important message",
                "row1": "The emergency remote collection should only be used in case of hardware failure and impossibility to make remote collections locally.",
                "row2": "Do you want to continue the emergency remote collection?",
                "row3": "Attention the launch of the emergency remote collection will trigger the blocking of the terminal on the gateway to prevent the transactions from being remitted twice."
            },
            "contract_selection": {
                "instruction": "Select the VAD contract for the merchant {{label}}",
                "error": "Only PAX terminals with the Payludd solution and a customization applied can launch an emergency remote collection.",
                "redirect": "You don't have any VAD contract, please create one by clicking here."
            },
            "remote_collections_selection": {
                "subtitle": "Sélection des remises"
            },
            "summarize": {
                "warning": "The transactions that have been refused will not be sent during the emergency remote collection.",
                "table": {
                    "col1": "Contract Rank",
                    "col2": "Number of debits",
                    "col3": "Amount of debits",
                    "col4": "Number of credits",
                    "col5": "Amount of credits",
                    "col6": "Number of cancellations",
                    "col7": "Amount of cancellations",
                    "col8": "Total amount"
                },
                "total": "Total:"
            },
            "steps": {
                "warning": "Step {{step}} sur {{maxStep}}: Warning",
                "contract_selection": "Step {{step}} sur {{maxStep}}: VAD contract selection",
                "remote_collections_selection": "Step {{step}} sur {{maxStep}}: Remote collections selection",
                "summarize": "Step {{step}} sur {{maxStep}}: Summary of the transactions for the emergency remote collection"
            },
            "success": "The emergency remote collection has been launched successfully. Warning, this operation may take a few minutes.",
            "error": "An error occurred while launching the emergency remote collection."
        }
    },
    "status": {
        "TO_BE_ACTIVATED": "Pending",
        "ACTIVATED": "Activated",
        "TERMINATED": "Terminated",
        "IN_STOCK": "In stock"
    },
    "status_init": {
        "INIT_OK": "Success",
        "INIT_KO": "Fail",
        "PASSERELLE_PRELUDD_KO": "Gateway fail",
        "VERSION_APP_PAX_KO": "Pax version fail",
        "TELECHARGEMENT_KO": "Download fail",
        "PACKAGE_CHARGEMENT_KO": "Package fail",
        "KO_PAS_DE_BENEFICIAIRE": "Benifciary fail",
        "WEBAPP_TELECHARGEMENT_KO": "Application fail",
        "CONTRAT_KO": "Contract fail",
        "TLP_KO": "TLP fail"
    },
    "tooltip": {
        "subscriptions_tab": "This tab contains the Pos terminals that have received a Payludd customization."
    }
}